import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixKeysService } from '../../keys.service';
import { PixMenu } from '../../../models/pix-menu.enum';
import { PixKeyClaim } from '../../../models/key-claim.model';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { PixKeyClaimView } from '../../../models/key-claim-view.model';
import * as moment from 'moment';
import { PixKeysClaimService } from '../../keys-claim.service';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { Util } from '../../../../../utils/util';
import { PixKey } from '../../../models/key.model';

@Component({
	selector: 'app-pix-claims-list',
	templateUrl: './claims.component.html',
	styleUrls: ['./claims.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixClaimsListComponent implements OnInit {

	public dataSource: MatTableDataSource<PixKeyClaimView>;
	public displayedColumns: Array<string> = ['key', 'createDate', 'institution', 'name', 'others'];
	public list: PixKeyClaimView[] = [];

	constructor(
		private pixKeysClaimService: PixKeysClaimService,
		private router: Router,
		public dialog: MatDialog
	) {}

	ngOnInit(): void {
	}

	getList() {
		this.list = [];
		const beginDate = moment(new Date()).format('YYYY-MM-DD');

		this.pixKeysClaimService.getReceive(beginDate, '').subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const items = Util.keysToCamel(result.Retorno) as PixKeyClaim[];
				this.list = this.convertModelToView(items);
				this.dataSource = new MatTableDataSource(this.list);
			}
		}, error => {
			console.error(error);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	convertModelToView(items: PixKeyClaim[]): PixKeyClaimView[] {
		return items.map(item => new PixKeyClaimView(item));
	}

	openModalAprove() {
		this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Processo de portabilidade concluido com sucesso',
				topText: 'Chave de endereçamento CPF: 034.158.081-30',
				text: 'Agora, usuários do Pix podem fazer pagamentos para você informando essa chave, sem a necessidade de digitar seus dados.',
				btnName: 'Fechar'
			}
		});
	}

	openModalReprove() {
		this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Processo de portabilidade recusado',
				topText: 'Chave de endereçamento CPF: 034.158.081-30',
				text: 'Você recusou a portabilidade, a chave continua registrada nesta instituição financeira',
				btnName: 'Fechar'
			}
		});
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/keys/list/claims/claims.component.ts